module.exports = __webpack_public_path__ + "static/img/download-bg.f7687f6d.png";